import styled from 'styled-components';
import * as DefaultInput from 'petco-ui/elements/form/input/Input.styled';
import { themed } from '@/shared/ui/core';

export const RangeWrapper = styled.div`
  position: relative;
`;

export const RangeStyled = styled(DefaultInput.InputStyled)`
  border: 0;
  height: 30px;
  margin: 0.75rem 0 0;
  padding: 0;
  width: 100%;
  -webkit-appearance: none;

  &:focus {
    outline: none;
  }

  &:before,
  &:after {
    color: ${themed('primary.text')};
    font-size: 0.8rem;
    position: absolute;
    top: 0;
  }

  &:before {
    content: ${({ initiallabel }) => `"${initiallabel}"`};
    left: 0;
  }

  &:after {
    content: ${({ finallabel }) => `"${finallabel}"`};
    right: 0;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 11px;
    cursor: pointer;
    animate: 0.2s;
    background: ${themed('primary.lightGray')};
    border-radius: 5px;
  }

  &::-webkit-slider-thumb {
    height: 26px;
    width: 26px;
    border-radius: 15px;
    background: ${themed('primary.accent')};
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -8px;
  }

  &::-webkit-slider-thumb::after {
    content: "";
    position: absolute;
    top: 100%;
  }

  &:focus::-webkit-slider-runnable-track {
    background: ${themed('primary.lightGray')};
  }

  &::-moz-range-track {
    width: 100%;
    height: 11px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0 0 0 #000;
    background: ${themed('primary.lightGray')};
    border-radius: 5px;
    border: 0px;
  }

  &::-moz-range-thumb {
    box-shadow: 0 0 0 #000;
    border: 0;
    height: 26px;
    width: 26px;
    border-radius: 15px;
    background: ${themed('primary.accent')};
    cursor: pointer;
  }

  &::-ms-track {
    width: 100%;
    height: 11px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  &::-ms-fill-lower {
    background: ${themed('primary.lightGray')};
    border: 0px;
    border-radius: 2px;
    box-shadow: 0 0 0 #000;
  }

  &::-ms-fill-upper {
    background: ${themed('primary.lightGray')};
    border: 0px;
    border-radius: 2px;
    box-shadow: 0 0 0 #000;
  }

  &::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0 0 0 #000;
    border: 0px;
    height: 26px;
    width: 26px;
    border-radius: 15px;
    background: ${themed('primary.accent')};
    cursor: pointer;
  }

  &:focus::-ms-fill-lower {
    background: ${themed('primary.lightGray')};
  }

  &:focus::-ms-fill-upper {
    background: ${themed('primary.lightGray')};
  }
`;

export const RangeOutput = styled.output`
  color: ${themed('primary.text')};
  font-size: .95rem;
  left: 50%;
  position: absolute;
  top: 100%;
  transform: translateX(-50%);
`;
